// @flow
import AgeRangeReaches, { type AgeRangeReachesData } from 'common/domain/AgeRangeReaches';
import GenderReach, { type GenderReachData } from 'common/domain/GenderReach';

type DemographicReachData = {
  ageRangeReach: AgeRangeReachesData,
  genderReach: GenderReachData,
}

export default class DemographicReach {
  ageRangeReaches: AgeRangeReaches;
  genderReach: GenderReach;

  constructor(ageRange: AgeRangeReaches, gender: GenderReach) {
    this.ageRangeReaches = ageRange;
    this.genderReach = gender;
  }

  hasEmptyGenderReach(): boolean {
    return this.genderReach.isEmpty();
  }

  hasEmptyAgeRangeReach(): boolean {
    return this.ageRangeReaches.isEmpty();
  }

  isEmpty(): boolean {
    return this.hasEmptyAgeRangeReach() && this.hasEmptyGenderReach();
  }

  toJSON(): DemographicReachData {
    return {
      ageRangeReach: this.ageRangeReaches.toJSON(),
      genderReach: this.genderReach.toJSON(),
    };
  }

  static parse(data: DemographicReachData): DemographicReach {
    const ageRangeReaches = AgeRangeReaches.parse(data.ageRangeReach);
    const genderReaches = new GenderReach(data.genderReach.female, data.genderReach.male);
    return new DemographicReach(ageRangeReaches, genderReaches);
  }

  static empty(): DemographicReach {
    return new DemographicReach(AgeRangeReaches.empty(), GenderReach.empty());
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/demography/domain/DemographicReach.js